(() => {
  const ROOT = '[data-card-variant-swatches]';
  const BTN = '[data-card-swatch]';
  const MORE = '[data-card-swatch-more]';

  function getCard(el) {
    return el.closest('.card-wrapper, .product-card-wrapper, .card');
  }

  function getPrimaryImage(card) {
    return (
      card.querySelector('[data-card-primary-image]') ||
      card.querySelector('.card__media img') ||
      card.querySelector('.media img')
    );
  }

  function updateLinks(card, url) {
    if (!url) return;
    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.href = url;
    });
  }

  function applySwatch(btn) {
    const card = getCard(btn);
    if (!card) return;

    const img = getPrimaryImage(card);
    const src = btn.getAttribute('data-image-src');
    const srcset = btn.getAttribute('data-image-srcset');
    const alt = btn.getAttribute('data-image-alt');

    if (img && src) {
      img.src = src;
      if (srcset) img.srcset = srcset;
      if (alt) img.alt = alt;
      img.classList.add('is-swatch-active');
      img.classList.add('card__media-image');
    }

    updateLinks(card, btn.getAttribute('data-variant-url'));

    const root = btn.closest(ROOT);
    if (root) {
      root.querySelectorAll(BTN).forEach((el) => el.classList.toggle('is-active', el === btn));
    }
  }

  function onMore(e) {
    const more = e.target.closest(MORE);
    if (!more) return;
    e.preventDefault();
    e.stopPropagation();

    const root = more.closest(ROOT);
    if (!root) return;

    if (!more.dataset.countLabel) {
      more.dataset.countLabel = more.textContent.trim();
    }

    const expanded = more.getAttribute('aria-expanded') === 'true';
    const nextExpanded = !expanded;
    more.setAttribute('aria-expanded', String(nextExpanded));
    more.textContent = nextExpanded ? '−' : more.dataset.countLabel;

    root.querySelectorAll(`${BTN}.is-extra`).forEach((btn) => {
      if (nextExpanded) btn.removeAttribute('hidden');
      else btn.setAttribute('hidden', '');
    });
  }

  document.addEventListener('mouseover', (e) => {
    const btn = e.target.closest(BTN);
    if (!btn) return;
    applySwatch(btn);
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest(MORE)) {
      onMore(e);
      return;
    }
    const btn = e.target.closest(BTN);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(btn);
  });

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const btn = e.target.closest(BTN);
      if (!btn) return;
      e.preventDefault();
      applySwatch(btn);
    },
    true
  );
})();
